$(function(){
  const swiper = new Swiper(".swiper", {
  // オプション設定
    loop: true,
    initialSlide: 0,
    speed: 600,
    slidesPerView: 'auto',
    centeredSlides:true,
    spaceBetween: 26, // スライド間の余白サイズ(ピクセル)
    direction: 'horizontal',
    effect: 'slide',
    autoplay: { // 自動再生
      delay: 2000, // 2秒後に次のスライド
    },
    pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
});